import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { ENGINE_FORM_SERVICE } from './models/iengine-form-service.model';
import { DefaultEngineFormService } from './services/default-engine-form.service';
import { FormValueMapper } from './services/form-value-mapper.service';

export function provideEngineForms(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: ENGINE_FORM_SERVICE, useClass: DefaultEngineFormService },
    FormValueMapper,
  ]);
}
